import React, { useMemo } from 'react';
import { useChatStore } from '@modules/chat/store/chatStore';
import { useRequest } from '@common/services/api';
import { useAppSelector } from '@common/hooks';
import { selected } from '@modules/organisation/selectors/organisation';
import { EFileTypes } from '@common/definitions';
import { Spinner } from '@common/components/spinner';
import { PureList } from '@common/components/list';
import { Attachment as AttachmentType } from '@common/types/objects';
import Attachment from '@common/components/attachment';
import { useTranslation } from 'react-i18next';
import { Button } from '@common/components/button';
import Placeholder from '@common/components/placeholder';



const MediaList = () => {

  const { t } = useTranslation();
  const orgId = useAppSelector(selected).id;



  const {
    conversationId,
  } = useChatStore();


  const apiConfig = useMemo(() => ({
    useCursor: true,
    limit: 20,
    payload: {
      type: [EFileTypes.IMAGE, EFileTypes.VIDEO, EFileTypes.GIF],
    },
    cachePolicy: 'no-cache',
  }), []);

  const apiUrl = useMemo(() => {
    const baseUrl = `/v3/organisations/${orgId}/conversations/${conversationId}/attachments`;
    return baseUrl;
  }, [orgId, conversationId]);

  const {
    data: mediaFiles,
    loading,
    meta,
    refetch
  } = useRequest(apiUrl, apiConfig);

  const pagination = useMemo(() => meta?.pagination, [meta?.pagination]);

  return (
    <PureList<AttachmentType, {}>
      containerClassName="tw-h-[calc(100vh-189px)] tw-block tw-overflow-y-auto tw-pl-4 tw-pt-4"
      items={mediaFiles as AttachmentType[]}
      renderRow={({ item }) => {
        return (
          <div className="tw-flex tw-items-center tw-justify-center tw-overflow-hidden
          tw-rounded tw-h-[80px] tw-w-[140px] tw-float-left tw-bg-[#eee] tw-mb-4 tw-ml-4"
          >
            <Attachment
              item={item}
              size="small"
              maxHeight={80}
              preview={item.file_type === EFileTypes.VIDEO}
              className="tw-scale-[1.8] hover:tw-scale-[1.9] tw-transition-transform"
            />
          </div>
        );
      }}
      footer={
        <div className="tw-items-center tw-justify-center tw-px-4">
          {!!pagination?.next_cursor && (
            <Button
              className="tw-text-center tw-font-semibold tw-clear-both tw-border-solid
              tw-border-background tw-w-full tw-relative tw-cursor-pointer
              "
              onClick={refetch}
              isLoading={loading}
            >
              {t('chat:conversations_load_more')}
            </Button>
          )}
        </div>
      }
      placeholder={
        loading
          ? <Spinner centered />
          : <Placeholder
              title={t('chat:no_media_found')}
          />
      }
    />
  );
};

export default React.memo(MediaList);
